"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunProgramAutoTestStep = void 0;
const base_1 = require("./base");
const utils_1 = require("./utils");
class RunProgramAutoTestStep extends base_1.BaseAutoTestStep {
    parseInputData(data) {
        return data;
    }
    getDataToSave() {
        return (0, utils_1.mergeEithers)(this._baseGetDataToSave(), (0, utils_1.errOrData)(this._checkProgramNotEmpty(), { data: this.data, type: this.type }));
    }
}
exports.RunProgramAutoTestStep = RunProgramAutoTestStep;
